import { render, staticRenderFns } from "./MenuWrapper.vue?vue&type=template&id=0ead080c"
import script from "./MenuWrapper.vue?vue&type=script&lang=js"
export * from "./MenuWrapper.vue?vue&type=script&lang=js"
import style0 from "./MenuWrapper.vue?vue&type=style&index=0&id=0ead080c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports